module.exports = __webpack_public_path__ + "static/media/BrixSans-Light.e819a380.ttf";